module.exports = __webpack_public_path__ + "1793882494189/fonts/fa-regular-400.e6c93cb.eot";